export default class MapLayerVisibility {
  public idMapLayer: number = 0;
  public isVisible: boolean = false;
}
